import { EmblaCarousel } from '../EmblaCarousel';
import { StyledImage, StyledImageWrapper } from './ImagesCarousel.styles';
import type { CaseStudyImagesCarouselProps } from './ImagesCarousel.types';

export const CaseStudyImagesCarousel = ({
  images,
}: CaseStudyImagesCarouselProps) => (
  <>
    {images?.length ? (
      images.length > 2 ? (
        <EmblaCarousel
          slides={Array.from(Array(images.length).keys())}
          items={images}
          options={{ loop: true }}
        />
      ) : images.length > 1 ? (
        <StyledImageWrapper customWidth="100%">
          <StyledImage
            desktopWidth="half"
            src={images[0].img}
            alt={images[0].alt}
          />
          <StyledImage
            desktopWidth="half"
            src={images[1].img}
            alt={images[1].alt}
          />
        </StyledImageWrapper>
      ) : (
        <StyledImageWrapper>
          <StyledImage src={images[0].img} alt={images[0].alt} />
        </StyledImageWrapper>
      )
    ) : null}
  </>
);
